import { create } from "zustand";
import axios from "axios";

const authStore = create((set) => ({
    //state
    loggedIn: null,
    user: null,
    
    loginForm: {
        email: "",
        password: "",
    },

    signupForm: {
        username: "",
        email: "",
        password: "",
    },

    updateLoginForm: (e) => {
        try {
            const { name, value } = e.target;

            set(state => {
                return {
                    loginForm: {
                    ...state.loginForm,
                    [name]: value,
                    },
                };
            });
        } catch (err) {
            
        }
    },

    updateSignupForm: (e) => {
        try {
            const { name, value } = e.target;

            set(state => {
                return {
                    signupForm: {
                    ...state.signupForm,
                    [name]: value,
                    },
                };
            });
        } catch (err) {

        }
    },

    login: async (e) => {
        try {
            const { loginForm } = authStore.getState();
            const res = await axios.post('/login', loginForm);

            set({ loggedIn: true, user: {email: res.data.email }});

            // Clear the form fields
            set({
                loginForm: {
                    email: "",
                    password: "",
                },
            }); 
        }  catch (err) {
            return 'error';
        }
    },

    checkAuth: async (e) => {
        try {
            const res = await axios.get("/check-auth");
            set ({ loggedIn: true, user: {email: res.data.email } }); 
        } catch (err) {
            set({ loggedIn: false, user: null });
        }
    },

    signup: async (e) => {
        try {
            const { signupForm } = authStore.getState();

            const res = await axios.post('/signup', signupForm);

            // Clear the form fields
            set({
                signupForm: {
                    username: "",
                    email: "",
                    password: "",
                },
            });
            return res.data;
        } catch (err) {
            return err;
        }
    },

    logout: async () => {
        try {
            await axios.get("/logout");
            set({ loggedIn: false, user: null });
        } catch (err) {

        }
    }

}));

export default authStore;